import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Save, ArrowLeft } from 'lucide-react';
import { AgreementShell, Action, Notice } from './Shared';
import { TermsFields, EMPTY_TERMS, toPayload } from './TermsFields';
import { agreementAPI, errorText } from './api';

export default function ExistingClientForm() {
  const { clientId, agreementId } = useParams();
  const navigate = useNavigate();
  const createdClient = useRef(clientId);
  const [terms,setTerms] = useState({...EMPTY_TERMS});
  const [loading,setLoading] = useState(Boolean(clientId));
  const [busy,setBusy] = useState(false);
  const [error,setError] = useState('');
  useEffect(() => {
    if (!clientId) return;
    agreementAPI.client(clientId).then(({data:{data}}) => {
      const draft = agreementId ? data.agreements.find(a => a.id === agreementId && a.status === 'draft') : null;
      if (agreementId && !draft) { setError('This draft is no longer editable.'); return; }
      setTerms({...EMPTY_TERMS,...(draft?.terms || data.terms), effective_date:draft?.terms.effective_date || ''});
    }).catch(e => setError(errorText(e))).finally(() => setLoading(false));
  },[clientId,agreementId]);
  const save = async event => {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError('');
    try {
      const payload = toPayload(terms);
      if (agreementId) await agreementAPI.update(agreementId,payload);
      else {
        if (!createdClient.current) { const response = await agreementAPI.add(payload); createdClient.current = response.data.data.client_id; }
        await agreementAPI.create(createdClient.current,payload);
      }
      navigate(`/admin/agreements/${createdClient.current}`);
    } catch (e) { setError(errorText(e)); window.scrollTo({top:0,behavior:'smooth'}); }
    finally { setBusy(false); }
  };
  return <AgreementShell title={agreementId ? 'Edit agreement draft' : clientId ? 'New agreement revision' : 'Add existing client'} eyebrow="Client agreements" back={clientId ? `/admin/agreements/${clientId}` : '/admin/agreements'}>
    <Notice error id="agreement-form-error">{error}</Notice>
    {loading ? <p data-testid="agreement-form-loading">Loading client details…</p> : <form onSubmit={save} data-testid="existing-client-form">
      <TermsFields values={terms} setValues={setTerms}/>
      <div className="ag-form-footer"><Action secondary data-testid="draft-cancel-button" onClick={() => navigate(clientId ? `/admin/agreements/${clientId}` : '/admin/agreements')}><ArrowLeft size={16}/> Cancel</Action>
        <Action type="submit" disabled={busy} data-testid="save-agreement-draft-button"><Save size={16}/>{busy ? 'Saving…' : 'Save draft'}</Action></div>
    </form>}
  </AgreementShell>;
}